import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface WithdrawConsentResult {
    cpr: string;
    userId: number;
}

@Injectable({
    providedIn: 'root'
})
export class ConsentService {

    constructor(private readonly http: HttpClient) { }

    postRetrievePatientConsent$(): Observable<boolean> {
        return this.http.post<boolean>(`${environment.backendUrl}/patient/hasconsent`, null)
    }

    postApprovePatientConsent$(): Observable<boolean> {
        return this.http.post<boolean>(`${environment.backendUrl}/patient/approveconsent`, null)
    }

    postWithdrawPatientConsent$(cpr: string): Observable<WithdrawConsentResult> {
        return this.http.post<any>(`${environment.backendUrl}/patient/withdrawconsent`, cpr )
    }
}